import { LicenseStatus, ProjectLicenseDto, ProjectLicenseIssues } from '@/types';
import { request } from '@/utils/ajax';
export function getLicenseIssues(): Promise<ProjectLicenseIssues[]> {
    return request(`api/license/issues`).then((x) => x.json());
}

export function getProjectLicenses(projectId: number): Promise<ProjectLicenseDto[]> {
    return request(`api/license/project/${projectId}`).then((x) => x.json());
}

export function setProjectLicenses(projectId: number, licesnses: ProjectLicenseDto[]): Promise<Response> {
    return request(`api/license/project/${projectId}`, {
        body: licesnses,
        method: 'PUT',
        json: true,
    });
}

export function getProjectLicenseStatus(projectId: number): Promise<LicenseStatus[]> {
    return request(`api/license/project/${projectId}/status`).then((x) => x.json());
}
